'use client'

import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface Props {
  open: boolean
  onClose: () => void
  onSubmit: (url: string) => void
  initialUrl?: string
}

export function VideoUrlModal({
  open,
  onClose,
  onSubmit,
  initialUrl = '',
}: Props) {
  const [url, setUrl] = useState(initialUrl)

  // 🔑 CLAVE: sincronizar cuando se abre
  useEffect(() => {
    if (open) {
      setUrl(initialUrl)
    }
  }, [open, initialUrl])

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Agregar video</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <Input
            placeholder="Pega la URL de YouTube, Vimeo o embed"
            value={url}
            onChange={e => setUrl(e.target.value)}
          />

          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              onClick={() => {
                if (url.trim()) {
                  onSubmit(url.trim())
                  setUrl('')
                }
              }}
            >
              Agregar video
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
